<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      :finish-button-text="(this.pengajuFound === true)?'Revisi':''"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- personal details tab -->
      <tab-content
        title="Berkas Lampiran"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Lampiran
              </h5>
              <small class="text-muted">Lengkapi Berkas Lampiran Anda</small>
            </b-col>
          </b-row>
          <b-row
            v-for="(value, index) in berkas.jenis_dokumen"
            :key="index"
          >
            <b-col
              cols="12"
              class="mb-2"
            >
              <b-row>
                <b-col md="6">
                  <b-form-group
                  >
                    <label>{{ value.nama }} <span class="required" v-if="value.required === 1">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      :name="value.key_file"
                    >
                      <div class="d-flex">
                        <b-form-file
                          ref="file-input"
                          :id="value.key_file"
                          v-model="file[value.key_file]"
                          :value="value.nama_file"
                          accept="application/pdf"
                          required
                        />
                        <b-button
                          v-if="value.nama_file !== null"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="success"
                          class="mb-75 mr-75 ml-1"
                          @click="lihatFile(value.nama_file)"
                        >
                          Lihat
                        </b-button>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                      <!-- <small class="text-danger" v-if="value.required === 1 && file[value.key_file] === []">File wajib di upload</small> -->
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <label for="">{{ value.deskripsi }}</label>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Informasi Penelitian"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Informasi Penelitian
              </h5>
              <small class="text-muted">Lengkapi informasi penelitian anda</small>
            </b-col>
          </b-row>
          <b-row>
          <b-col md="12">
            <b-form-group label="1. Sebutkan secara singkat latar belakang dan tujuan dari penelitian:*" label-for="latarBelakang">
              <validation-provider
                #default="{ errors }"
                name="Latar Belakang"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.latarBelakang" id="Latar Belakang" rows="3" required></b-form-textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="2. Jelaskan secara singkat metode penelitian:*" label-for="metodePenelitian">
              <validation-provider
                #default="{ errors }"
                name="Metode Penelitian"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.metodePenelitian" id="Metode Penelitian" rows="3" required></b-form-textarea>
               <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="3. Jelaskan secara singkat perencanaan dan/atau timeline penelitian yang akan dilakukan:*" label-for="perencanaan">
              <validation-provider
                #default="{ errors }"
                name="Perencanaan"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.perencanaan" id="Perencanaan" rows="3" required></b-form-textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="4. Siapa yang menjadi partisipan penelitian ini? (Beri tanda √ pada kotak yang tersedia). Berikan pula uraian mengenai karakteristik partisipan penelitian:*" label-for="partisipan">
              <validation-provider
                #default="{ errors }"
                name="Partisipan"
                rules="required"
              >
                <b-form-checkbox-group v-model="jawaban.partisipan" id="Partisipan">
                  <b-form-checkbox value="Mahasiswa" @input="handleCheckboxChange">Mahasiswa</b-form-checkbox>
                  <b-form-checkbox value="Anak-anak" @input="handleCheckboxChange">Anak-anak (0 s/d &lt;18 tahun)</b-form-checkbox>
                  <b-form-checkbox value="Masyarakat Umum" @input="handleCheckboxChange">Masyarakat umum</b-form-checkbox>
                  <br/>
                  <b-form-checkbox value="Populasi Khusus" @input="handleCheckboxChange">Populasi khusus (sebutkan)</b-form-checkbox>
                  <b-form-input v-if="jawaban.partisipanPopulasiKhusus === true" v-model="jawaban.populasiKhususText"></b-form-input>
                  <b-form-checkbox value="Sampel Komunitas" @input="handleCheckboxChange">Sampel Komunitas (sebutkan umur dan cara perolehan partisipan)</b-form-checkbox>
                  <b-form-input v-if="jawaban.partisipanSampelKomunitas === true" v-model="jawaban.sampelKomunitasText"></b-form-input>
                  <b-form-checkbox value="Lainnya" @input="handleCheckboxChange">Lainnya (sebutkan)</b-form-checkbox>
                  <b-form-input v-if="jawaban.partisipanLainnya === true" v-model="jawaban.lainnyaText"></b-form-input>
                </b-form-checkbox-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="5. Jelaskan prosedur merekrut partisipan:*" label-for="prosedurRekrut">
              <validation-provider
                #default="{ errors }"
                name="Prosedur Merekrut"
                rules="required"
              >
                 <b-form-textarea v-model="jawaban.prosedurRekrut" id="Prosedur Merekrut" rows="3" required></b-form-textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="6. Apakah ada imbalan yang diberikan kepada partisipan penelitian?*" label-for="imbalanPartisipan">
              <validation-provider
                #default="{ errors }"
                name="Imbalan"
                rules="required"
              >
                <b-form-radio-group v-model="jawaban.imbalanPartisipan" id="Imbalan">
                  <b-form-radio value="Ya">Ya, Jelaskan secara singkat prosedur pemberian reward:</b-form-radio>
                  <b-form-textarea v-if="jawaban.imbalanPartisipan === 'Ya'" v-model="jawaban.prosedurReward" rows="2" required></b-form-textarea>
                  <b-form-radio value="Tidak">Tidak</b-form-radio>
                </b-form-radio-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="7. Informed Consent*" label-for="informedConsent">
              <div><label>a) Untuk partisipan anak-anak, apakah ada informed consent dari orangtua/wali dan anak yang bersangkutan?</label></div>
              <validation-provider
                #default="{ errors }"
                name="Inform Consent Orangtua/Wali"
                rules="required"
              >
                <b-form-radio-group v-model="jawaban.informedConsentAnak" id="Inform Consent Orangtua/Wali">
                  <b-form-radio value="Ya">Ya</b-form-radio>
                  <b-form-radio value="Tidak">Tidak</b-form-radio>
                </b-form-radio-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <div><label>b) Apakah isi informed consent sudah mencakup:</label></div>
              <validation-provider
                #default="{ errors }"
                name="Isi Informed Consent"
                rules="required"
              >
                <b-form-checkbox-group v-model="jawaban.informedConsent" id="Isi Informed Consent">
                  <b-form-checkbox value="Diisi dalam keadaan sadar">Diisi dalam keadaan sadar</b-form-checkbox>
                  <b-form-checkbox value="Sukarela">Sukarela</b-form-checkbox>
                  <b-form-checkbox value="Bisa mengundurkan diri kapan saja tanpa konsekuensi">Bisa mengundurkan diri kapan saja tanpa konsekuensi</b-form-checkbox>
                  <b-form-checkbox value="Informasi tentang tujuan penelitian">Informasi tentang tujuan penelitian</b-form-checkbox>
                  <b-form-checkbox value="Informasi tentang batasan waktu yang dibutuhkan untuk pengambilan data">Informasi tentang batasan waktu yang dibutuhkan untuk pengambilan data</b-form-checkbox>
                  <b-form-checkbox value="Ada persetujuan partisipan">Ada persetujuan partisipan (tanda tangan/check list/dsb)</b-form-checkbox>
                </b-form-checkbox-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="8. Apakah prosedur penelitian mencakup hal-hal berikut?" label-for="prosedurPotensialDampak">
              <validation-provider
                #default="{ errors }"
                name="Prosedur Penelitian"
                rules=""
              >
                <b-form-checkbox-group v-model="jawaban.prosedurPotensialDampak" id="Prosedur Penelitian">
                  <b-form-checkbox v-for="option in prosedurPotensialDampakOptions" :key="option.value" :value="option.value" @input="handleCheckboxChangeProsedur">
                    {{ option.label }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input v-if="jawaban.dampakLainnya === true" v-model="jawaban.dampakProsedurLainnya"></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="9. Jelaskan prosedur debriefing:*" label-for="prosedurDebriefing">
              <validation-provider
                #default="{ errors }"
                name="Prosedur Debriefing"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.prosedurDebriefing" id="Prosedur Debriefing" rows="3" required></b-form-textarea>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="10. Jelaskan langkah antisipasi meminimalkan risiko dampak penelitian terhadap partisipan?" label-for="antisipasiResiko">
              <validation-provider
                #default="{ errors }"
                name="Langkah Antisipasi Minimalisir Resiko"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.antisipasiResiko" id="Langkah Antisipasi Minimalisir Resiko" rows="3" required></b-form-textarea>
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="11. Jelaskan manfaat penelitian (untuk partisipasi/institusi/komunitas/masyarakat luas):*" label-for="manfaatPenelitian">
              <validation-provider
                #default="{ errors }"
                name="Manfaat Penelitian"
                rules="required"
              >
                <b-form-textarea v-model="jawaban.manfaatPenelitian" id="Manfaat Penelitian" rows="3" required></b-form-textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="12. Untuk penelitian yang menggunakan alat ukur diagnostik psikologis, administrasi, skoring, dan interpretasi HARUS dilakukan oleh psikolog." label-for="namaPsikolog">
              <label>Nama Psikolog:</label>
              <b-form-input v-model="jawaban.namaPsikolog" id="namaPsikolog" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Nomor izin praktik resmi yang dikeluarkan oleh HIMPSI:" label-for="izinPraktikPsikolog">
              <validation-provider
                #default="{ errors }"
                name="Izin Praktik Psikolog"
              >
                <b-form-input v-model="jawaban.izinPraktikPsikolog" id="Izin Praktik Psikolog" required></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
         
        </validation-observer>
      </tab-content>

      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div class="d-flex justify-content-center mt-2">
            <b-spinner
            :variant="'dark'"
            ></b-spinner>
          </div>
          <div class="d-flex justify-content-center mt-2">
           Loading....
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { BFormTextarea, BButton, BFormGroup, BFormFile, BFormCheckboxGroup, BFormCheckbox, BFormRadioGroup, BFormRadio, BFormInput } from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/id.js'; // Import Indonesian language pack
import {
  BRow,
  BCol,
  // BFormGroup,
  // BFormInput,
  BFormInvalidFeedback,
  // BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  // BFormFile,
  // BFormTextarea,
  BModal,
  BSpinner,
  // BFormCheckboxGroup,
  // BFormCheckbox,
  // BFormRadioGroup,
  // BFormRadio,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { codeIcon } from './code'
import {
  getUserDetail,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetailByHasil,
  uploadFilePengajuan,
  downloadDokumen,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    FlatPickr,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      showModal: 1,
      file: {},
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      pengaju: "pengaju",
      pengajuFound: false,
      flatpickrConfig: {
        altInput: true,
        altFormat: 'j F Y', // Indonesian date format
        dateFormat: 'Y-m-d', // Actual date format used for the form
        locale: 'id', // Set locale to Indonesian
      },
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      checklist: [
        {
          text: 'Saya yang bertanda tangan di bawah ini, mengajukan permohonan kaji etik untuk proposal penelitian saya, yang sudah berdasarkan standar etika riset Psikologi, Kode Etik Penelitian Universitas Indonesia dan Kode Etik Penelitian Himpunan Psikologi Indonesia.',
          checked: false,
        },
      ],
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
       programOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Program --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Bidang Studi --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Penelitian --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
      ruanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Ruangan --' },
        ],
      },
      waktuUjianOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Waktu Ujian --' },
        ],
      },
      jawabanPersetujuanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jawaban --' },
        ],
      },
      prosedurPotensialDampakOptions: [
        { label: 'Secara potensial berdampak pada aspek kesehatan (misal, cedera, keracunan, kelelahan dll)', value: 'kesehatan' },
        { label: 'Secara potensial berdampak pada aspek psikologis (misal, memalukan, stres, dll)', value: 'psikologis' },
        { label: 'Prosedur terselubung (deception)', value: 'terselubung' },
        { label: 'Prosedur invasif (contohnya: pengambilan sampel darah, hormon atau air liur)', value: 'invasif' },
        { label: 'Obat-obatan', value: 'obat' },
        { label: 'Data dari periset lain (mis., meta analisis, dll)', value: 'dataPeriset' },
        { label: 'Tidak mencakup satu pun dari yang disebut di atas, sebutkan', value: 'lainnya' },
      ],
      jawaban: {
        latarBelakang: '',
        metodePenelitian: '',
        perencanaan: '',
        partisipan: [],
        partisipanPopulasiKhusus: false,
        partisipanSampelKomunitas: false,
        partisipanLainnya: false,
        partisipanPopulasiKhususText: '',
        partisipanSampelKomunitasText: '',
        partisipanLainnyaText: '',
        prosedurRekrut: '',
        imbalanPartisipan: '',
        prosedurReward: '',
        informedConsentAnak: '',
        informedConsent: [],
        prosedurPotensialDampak: [],
        dampakLainnya: false,
        dampakProsedurLainnya: '',
        prosedurDebriefing: '',
        antisipasiResiko: '',
        manfaatPenelitian: '',
        namaPsikolog: '',
        izinPraktikPsikolog: '',
      }
    }
  },
  mounted() {
    // console.log(this.file)
      this.$bvModal.show('modal-center-loading')
      var error_check = []
      var success_check = []
      if(!this.$route.params.uuid){
          postBerkas()
          .then(response => {
            if (response.data.success == true) {
              success_check.push('success')
              this.completeCheck(success_check)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Kaji Etik',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Redirecting ...',
                },
              })
              setTimeout(() => {
                this.$router.push({ 
                  name: 'pengajuan-kajietik-edit', 
                  params: { uuid: response.data.data.uuid } 
                })
              }, 1000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Kaji Etik',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
                duration: 5000,
              })
            }
          })
          .catch(error => console.log(error));
        } else {
          getPengajuanSidangDetailByHasil(this.$route.params.uuid)
            .then(response => {
              this.berkas = response.data.data;
              this.pengajuFound = this.berkas.rolesUser.includes(this.pengaju);
              if (this.berkas.jawaban.length > 0) {
                this.buildOption(this.berkas.jawabanPersetujuan, this.jawabanPersetujuanOption)
              }

              if (this.berkas.ruangan.length > 0) {
                this.buildOption(this.berkas.ruangan, this.ruanganOption)
              }

              if (this.berkas.dosen.length > 0) {
                this.buildOption(this.berkas.dosen, this.dosenOption)
              }

              if (this.berkas.waktu.length > 0) {
                this.buildOption(this.berkas.waktu, this.waktuUjianOption)
              }

              if (this.berkas.jurusan.length > 0) {
                this.buildOption(this.berkas.jurusan, this.jurusanOption)
              }

              if (this.berkas.proses_persidangan.length > 0) {
                this.buildOption(this.berkas.proses_persidangan, this.prosesPersidanganOption)
              }

              if (this.berkas.jenis_sidang.length > 0) {
                this.buildOption(this.berkas.jenis_sidang, this.jenisSidangOption)
              }

              // if(this.berkas.program.length > 0)
              // {
              //   this.buildOption(this.berkas.program, this.programOption)
              // }

              if (this.berkas.jenjang.length > 0) {
                this.buildOption(this.berkas.jenjang, this.jenjangOption)
              }

              if (this.berkas.prodi.length > 0) {
                this.buildOption(this.berkas.prodi, this.prodiOption)
              }

              if (this.berkas.peminatan.length > 0) {
                this.buildOption(this.berkas.peminatan, this.peminatanOption)
              }

              if (this.berkas.jenis_dokumen.length > 0) {
                // this.buildOption(this.berkas.peminatan, this.masterDokumen)
                 for (let i = 0; i < this.berkas.jenis_dokumen.length; i++) {
                  var key = this.berkas.jenis_dokumen[i].key_file
                  // if( this.berkas.jenis_dokumen[i].nama_file !== null)
                  // this.file[key] = [] 'name': this.berkas.jenis_dokumen[i].nama_file }
                  // else
                  this.file[key] = null
                }
                // console.log(this.file)
              }

              this.jawaban = this.berkas.jawaban;
              success_check.push('success')
              this.completeCheck(success_check)
            })
          .catch(error => console.log(error));
        }

        //API data
      // getJawabanPersetujuan()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.jawabanPersetujuanOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getRuangan()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.ruanganOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getDosen()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.dosenOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getWaktuUjian()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.waktuUjianOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getJurusan()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.jurusanOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getProsesPersidangan()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.prosesPersidanganOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getJenisSidang()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.jenisSidangOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getJenjang()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.jenjangOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getProgram()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.programOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getProdi()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.prodiOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });

      // getPeminatan()
      // .then(response => {
      // if (response.data.length > 0) {
      //   response.data.forEach(element => {
      //     this.peminatanOption.options.push({
      //       title: element.nama,
      //       value: element.uuid,
      //     })
      //   })
      //   success_check.push('success')
      //   this.completeCheck(success_check)
      // }
      // })
      // .catch(error => {
      //   error_check.push(error)
      // });
  },
  methods: {
    // checkIsPengaju: function() {
    //   const rolesUser = this.berkas.rolesUser;
    //   const pengaju = "pengaju";

    //   // Check if "pengaju" is present in the rolesUser array
    //   const pengajuFound = rolesUser.includes(pengaju);

    //   if (pengajuFound) {
    //     return true;
    //   }else{
    //     return false;
    //   }
    // },
    changedValue: function(value) {
      alert(value);
    },
    changedLabel: function(label) {
      alert(label);
    },
    updateChecklist() {
      // Add your logic here
      console.log(this.checklist);
    },
    buildOption(data, option) {
      data.forEach(element => {
        option.options.push({
          title: element.nama,
          value: element.uuid,
        })
      })
    },
    handleCheckboxChangeProsedur() {
      this.jawaban.dampakLainnya = false
      for (let i = 0; i < this.jawaban.prosedurPotensialDampak.length; i++) {
        if (this.jawaban.prosedurPotensialDampak[i] === 'lainnya') {
          this.jawaban.dampakLainnya = true
        }
      }
    },
    handleCheckboxChange() {
      // Perform actions based on checkbox state
      this.jawaban.partisipanPopulasiKhusus = false
      this.jawaban.partisipanSampelKomunitas = false
      this.jawaban.partisipanLainnya = false
      for (let i = 0; i < this.jawaban.partisipan.length; i++) {
        if(this.jawaban.partisipan[i] === 'Populasi Khusus') {
          this.jawaban.partisipanPopulasiKhusus = true
        }
        if (this.jawaban.partisipan[i] === 'Sampel Komunitas') {
          this.jawaban.partisipanSampelKomunitas = true
        }
        if (this.jawaban.partisipan[i] === 'Lainnya') {
          this.jawaban.partisipanLainnya = true
        }
      }
      // Add your logic here
    },
    completeCheck(success_check) {
      if (success_check.length > 0) {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    async downloadFile(file){
      const result = await downloadDokumen(file);
      const blob = new Blob([result.data], {type: 'application/vnd.ms-powerpoint'});
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `berkas-${date}.pptx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadDokumen(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Pengajuan Kaji Etik',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      this.pengajuFound = this.berkas.rolesUser.includes(this.pengaju);
      if(this.pengajuFound === true && window.confirm('Apakah anda yakin ingin melakukan revisi berkas kaji etik ini?'))
      {
         this.berkas.flag = 'Informasi Penelitian'
        //  this.berkas.berkas_presentasi = response.data.data;
          // this.berkas.informasi_penelitian = {
          //   latar_belakang: latarBelakang
          // }
          this.berkas.jawaban = this.jawaban
          updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Kaji Etik',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil direvisi',
                  },
                  duration: 5000,
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Kaji Etik',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil direvisi',
                  },
                })
              }
            })
            .catch(error => console.log(error));
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success && this.checklist[0].checked === true) {
            this.berkas.flag = 'Biodata'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                // this.$toast({
                //   component: ToastificationContent,
                //   props: {
                //     title: 'Pengajuan Kaji Etik',
                //     icon: 'EditIcon',
                //     variant: 'success',
                //     text: 'Data berhasil disimpan',
                //   },
                //   duration: 5000,
                // })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Kaji Etik',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: response.data.message,
                  },
                })
              }
            })
            .catch(error => console.log(error));
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            if (this.berkas.jenis_dokumen.length > 0) {
              // this.buildOption(this.berkas.peminatan, this.masterDokumen)
              this.berkas.flag = 'Berkas'
              // this.resolved = []
              for (let i = 0; i < this.berkas.jenis_dokumen.length; i++) {
                var key = this.berkas.jenis_dokumen[i].key_file
                // if( this.file[key] !== null)
                // {
                // console.log(this.file[key])
                if (this.file[key] != null) {
                  var metadata = { key_file: key, uuid: this.berkas.uuid }
                  uploadFilePengajuan(this.file[key], metadata, event => {
                    this.progress = Math.round((100 * event.loaded) / event.total)
                  })
                    .then(response1 => {
                      if (response1.data.success == true) {
                        this.berkas.jenis_dokumen[i].nama_file = response1.data.data;

                        updateBerkas(this.berkas)
                          .then(response => {
                            if (response.data.success == true) {
                              // this.$toast({
                              //   component: ToastificationContent,
                              //   props: {
                              //     title: 'Pengajuan Kaji Etik',
                              //     icon: 'EditIcon',
                              //     variant: 'success',
                              //     text: 'Data berhasil disimpan',
                              //   },
                              //   duration: 5000,
                              // })
                            } else {
                              this.$toast({
                                component: ToastificationContent,
                                props: {
                                  title: 'Pengajuan Kaji Etik',
                                  icon: 'EditIcon',
                                  variant: 'danger',
                                  text: response.data.message,
                                },
                              })
                            }
                          })
                          .catch(error => console.log(error));
                      }
                    })
                    .catch(error => console.log(error));
                }
                // }
                // if (this.berkas.jenis_dokumen[i].nama_file === null && this.berkas.jenis_dokumen[i].required) {

                // }
              }
            }
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress2() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules2.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
<style>
.custom-checkbox .custom-control-label, .custom-radio .custom-control-label {
  font-size: 0.857rem!important;
}
</style>